module.exports = "<div class=\"col-md-7 blanco\" ng-if=projectVM.thereIsDetails()> <div ng-include=\"'details-header-proposal'\"></div> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=projectVM.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=\"projectVM.thereIsDetails() || projectVM.searchValue\" md-diameter=96> </md-progress-circular> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/extensionVisibility/projectFormulation/list/proposals-details.html
// module id = 664
// module chunks = 0